import { render, staticRenderFns } from "./Informations.vue?vue&type=template&id=243b9180&scoped=true&"
import script from "./Informations.vue?vue&type=script&lang=ts&"
export * from "./Informations.vue?vue&type=script&lang=ts&"
import style0 from "./Informations.vue?vue&type=style&index=0&id=243b9180&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243b9180",
  null
  
)

export default component.exports